var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('footer',{staticClass:"fds-meta footer"},[_vm._v(" Contact "),_c('a',{attrs:{"href":"mailto: design@feelgood.se"}},[_vm._v("design@feelgood.se")]),_vm._v(" for help, questions or feedback ")])])
}]

export { render, staticRenderFns }